module.exports = __webpack_public_path__ + "img/pause.8df843e4.svg";